export enum PendoRegion {
  US = 'us',
  EU = 'eu'
}
